import { format, parseISO } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
export default (client) => {
    const parseUtcDate = (dateText) => utcToZonedTime(parseISO(dateText), "UTC");
    const loadOutagesByRange = (customerName, siteId, startDate, endDate) => client
        .get(`/camera/outages-range/${customerName}/${siteId}/${format(startDate, "yyyy-MM-dd")}/${format(endDate, "yyyy-MM-dd")}`)
        .then((response) => Object.entries(response.data).reduce((acc, [key, value]) => {
        acc[key] = value.map((item) => (Object.assign(Object.assign({}, item), { start_time: parseUtcDate(item.start_time), end_time: parseUtcDate(item.end_time), tml_start: parseUtcDate(item.tml_start), tml_end: parseUtcDate(item.tml_end) })));
        return acc;
    }, {}));
    return {
        loadOutagesByRange,
    };
};
//# sourceMappingURL=CameraRepository.js.map